/**
 * handlers/documents.ts
 * File attachment and document chip management.
 */

import { state } from '../state';
import { embedDocument } from '../api';
import { showDocChip, clearDocChip, showRecentDocsGrid } from '../ui-renderers';

export function handleFileAttach(file: File) {
  state.attachedFileName   = file.name;
  state.attachedDocumentId = 'upload_' + Date.now() + '_' + file.name.replace(/[^a-z0-9.]/gi, '_');
  showDocChip(file.name);
  embedDocument(state.attachedDocumentId, file.name).catch(e => {
    console.warn('[AkiliBrain] embed failed:', e);
  });
}

export function clearAttachedDocument() {
  state.attachedDocumentId = null;
  state.attachedFileName   = '';
  clearDocChip();
}

// Re-export so callers can do: import { showRecentDocsGrid } from './handlers'
export { showRecentDocsGrid };
